import { nullToUndefined } from '@pn/core/utils/logic';
import { cloneDeep, isNil } from 'lodash-es';

export class HistoryManager<T> {
  private initSnapshot: T;
  private undoStack: T[] = [];
  private redoStack: T[] = [];

  constructor(snapshot: T) {
    this.initSnapshot = cloneDeep(snapshot);
  }

  reinit(snapshot: T): void {
    this.initSnapshot = cloneDeep(snapshot);
    this.undoStack = [];
    this.redoStack = [];
  }

  add(snapshot: T): void {
    this.undoStack.push(cloneDeep(snapshot));
    this.redoStack = []; // clear the redo stack whenever a new snapshot is added
  }

  undo(): T | undefined {
    if (this.undoStack.length === 0) return undefined;

    const snapshot = this.undoStack.pop();
    if (!isNil(snapshot)) this.redoStack.push(snapshot);
    return cloneDeep(
      this.undoStack[this.undoStack.length - 1] ?? this.initSnapshot
    );
  }

  redo(): T | undefined {
    if (this.redoStack.length === 0) return undefined;

    const snapshot = this.redoStack.pop();
    if (!isNil(snapshot)) this.undoStack.push(snapshot);
    return nullToUndefined(cloneDeep(snapshot));
  }

  peek(): T {
    return cloneDeep(
      this.undoStack[this.undoStack.length - 1] ?? this.initSnapshot
    );
  }

  length(): number {
    return this.undoStack.length;
  }
}
